<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <div class="info shadow-bg">
                <div class="bh bc">
                    <div class="loginlog bg-contain"></div>
                </div>第1步：领取 兑换成功后，点击查看详情或者商城首页，点击【个人中心】-【我的订单】，选择兑换订单，查看订单详情，选择【领取使用】，输入下单时的手机号码，领取成功后相应的代驾劵自动存入您的e代驾账户。
                <br />第2步：使用下载并安装e代驾APP或者e代驾小程序，使用下单手机号登录即可。
                <validation-observer v-slot="{ invalid }">
                    <div class="divider"></div>
                    <div class="bh bstart container-group">
                        <validation-provider
                            rules="required|mobile"
                            v-slot="{ errors }"
                            name="手机号码"
                            class="container-group-el b1"
                            slim
                        >
                            <van-field
                                v-model="params.telephone"
                                class="r4 shadow-bg telephoneText b1"
                                clearable
                                maxlength="11"
                                placeholder="请输入手机号码"
                            >
                                <zb-warning slot="right-icon" :message="errors[0]" />
                            </van-field>
                        </validation-provider>
                        <van-button
                            :disabled="invalid||isExchangeEnd"
                            class="btn btn-buy "
                            @click="onExchangeClick(params)"
                        >
                            <span class="fz_28">立即领取</span>
                        </van-button>
                    </div>
                </validation-observer>
                <div class="coupons-list">
                    <div v-for="(item,i) in data" :key="i" class="list-item">
                        <div class="item bg-100 bh img-coupons">
                            <div class="left bv bc">{{item.price}}</div>
                            <div class="bv b1 right">
                                <div class="fz_36 exchange">e代驾服务一次</div>
                                <div class="bh">
                                    <div class>使用说明：</div>
                                    <div class="b1">
                                        <div>1.仅限有效期内适用</div>
                                        <div>2.关注“e代驾”公众号后使用</div>
                                        <div>3.仅限下单手机号使用</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="prompt-container fz_24" v-if="data.length">注：若代驾券未到账，请联系管理员反馈。</div>
            </div>
            <div class="line"></div>
        </div>
    </div>
</template>
<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import { exchangeCoupons } from "@/api/user";

export default {
    mixins: [routeCache, user],
    name: "CartOrderExchange",
    data() {
        return {
            isExchangeEnd: false,
            data: [],
            params: { isExchangeEnd: false }
        };
    },
    methods: {
        // 获取用户数据后执行
        userLoginend() {
            const me = this;
            me.params = me.getCache();
            me.isExchangeEnd = me.params.isExchangeEnd;
        },
        // 兑换成功
        onExchangeClick(params) {
            exchangeCoupons(params).then(res => {
                const me = this,
                    data = res.data,
                    success = data.successNum,
                    type = success ? "success" : "fail",
                    mes = success ? "兑换成功" : "兑换失败，请联系管理员";
                if (success) {
                    // 标识需要更新用户订单列表数据
                    me.$store.state.cart.isUpdateUserOrder = true;
                    // 显示兑换成功的劵
                    const list = [];
                    list.push({
                        price: data.denomination
                    });
                    me.data = list;
                    // 兑换成功后重置兑换状态，避免重复兑换
                    const params = me.params;
                    params.isExchangeEnd = true;
                    me.isExchangeEnd = true;
                    me.setCache(params);
                }
                me.toast.show({
                    message: mes,
                    type: type
                });
            });
        }
    }
};
</script>
<style scoped lang="scss">
.scrollbar-container {
    padding: 0 30px 0 30px;
    .info {
        padding: 0 25px;
        background: #fff5e9;
        .loginlog {
            width: 296px;
            height: 102px;
            margin: 60px 0;
            background-image: url("~@/assets/imges/user/loginlog.png");
        }
        .divider {
            height: 60px;
            border-bottom: 1px dashed #ff9a2b;
        }
        .container-group {
            padding: 60px 0 48px 0;

            /deep/ .van-cell {
                height: 80px;
                padding: 0 15px;
                .van-field__body {
                    height: 100%;
                }
            }
            .btn-buy {
                @include border-radius(4px 6px 6px 6px);
                width: 160px;
                height: 80px;
                margin-left: 15px;
            }
        }
        .coupons-list {
            .list-item {
                padding: 11px 0;
                .item {
                    color: #fff;
                    &.img-coupons {
                        background-image: url("~@/assets/imges/user/coupons.png");
                    }
                    .left {
                        color: #ff9a2b;
                        width: 200px;
                        font-size: 80px;
                    }
                    .right {
                        padding: 20px 20px 20px 35px;
                        font-size: 18px;
                        .money {
                            height: 90px;
                            line-height: 90px;
                            .ico {
                                width: 67px;
                                height: 71px;
                            }
                            .text {
                                margin-left: 10px;
                                font-size: 80px;
                            }
                        }
                    }
                }
            }
        }
        .prompt-container {
            color: #f38e1e;
            padding: 27px 0 60px 0;
        }
    }
}
</style>
